function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.dataset.magnifyImage}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  overlayImage.onload = () => {
    image.parentElement.insertBefore(overlay, image);
  }

  return overlay;
};

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  let xPosition = event.clientX - container.left;
  let yPosition = event.clientY - container.top;
  if (event.type == 'touchstart' || event.type == 'touchmove') {
    xPosition = event.touches[0].clientX - container.left;
    yPosition = event.touches[0].clientY - container.top;
  }
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
};

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach(image => {
    image.addEventListener('mouseenter', (event) => {
      const touchDevice = isTouchDevice();

      if (touchDevice) return;

      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    });
  });
}

enableZoomOnHover(2);
